import React, {memo} from 'react';
import Rete from 'rete';
import Autocomplete from "@mui/material/Autocomplete";
import {AutocompleteInput} from "./components/AutocompleteInput";
import CustomPopper from "./components/CustomPopper";

const Search = memo(({editor, labelText, selectedOption, selectOptions, handleChange, handleFocus}) => {

    return (
        <Autocomplete
            size="small"
            disablePortal={true}
            disableClearable
            value={selectedOption}
            options={selectOptions}
            onChange={handleChange}
            onFocus={handleFocus}
            renderInput={(params) => <AutocompleteInput params={params} label={labelText} />}
            ListboxProps={{style: {scrollbarWidth: "thin"}}}
            // HACK: there is an issue with autocomplete default popper in zoomed content
            // (which clearly Rete.NodeEditor is)
            // we 'fixed' it in CustomPopper component file - more info there
            PopperComponent={CustomPopper}
        />
    )
});

export class SearchControl extends Rete.Control {

    static get DEFAULT_VALUE() {
        return "";
    };

    constructor(editor, key, node, readonly = false, labelText, selectOptions, selectedOption = null) {
        super(key);
        // this.render = 'react'; // required?
        this.key = key;
        this.component = props => (
            <Search {...props} />
        );

        const initial = node.data[key] || SearchControl.DEFAULT_VALUE;
        node.data[key] = initial;

        this.props = {
            readonly,
            editor,
            labelText: labelText,
            selectedOption: selectedOption,
            selectOptions: selectOptions,
            handleChange: (event, selectedOption, reason)  => {
                this.props.selectedOption = selectedOption;
                this.putData(this.key, selectedOption.value);
                this.update();
                editor.trigger("process");
            },
            handleFocus: () => {
                this.updateSelectedOption(this.props.selectedOption ?? initial);
            },
        };

        if (initial === SearchControl.DEFAULT_VALUE && selectedOption != null) {
            // if control is created (not loaded) and has selectedOption set
            // change selected option in Select component with value given by user
            let isUpdated = this.updateSelectedOption(selectedOption);
            // if selected value is successfully updated then put it to Node, so it can be saved and received later
            // we do saving in rendercontrol event, because there Rete.Control will exist, in constructor Rete.Control doesn't exist yet;
            editor.on("rendercontrol", ({el, control}) => {
                if (control.key === this.key && isUpdated) {
                    this.putData(this.key, this.props.selectedOption.value);
                }
            });
        } else {
            // if control is loaded
            // change selected option in Select component with loaded value
            // there is no need to check if value was correctly updated - it always be
            this.updateSelectedOption(initial);
        }

        // test rendercontrol also?
    }

    updateSelectedOption(selectedValue) {
        if (selectedValue !== SearchControl.DEFAULT_VALUE) {
            let foundSelected = this.props.selectOptions.find(selectOption => selectOption.value === selectedValue);
            if (foundSelected !== undefined) {
                this.props.selectedOption = foundSelected;
                return true;
            }
        }

        if (typeof this.update === 'function') {
            this.update();
        }

        return false;
    }
}